import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Devices from './components/Devices';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Results from './components/Results';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Devices />
      <Problem />
      <Solution />
      <Results />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App; 